import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { ChangePasswordComponent } from '../../components/Profile/ChangePasswordComponent';
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from '../../components/share/Footer';

export function ChangePasswordContainer() {
    const titleName = "เปลี่ยนรหัสผ่าน";

    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ChangePasswordComponent />
            <Footer />
        </div>
    );

} 